<template>
  <div class="gc-info-wrap">
    <van-nav-bar :border="false"
                 :title="title"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="page-info-wrap">
      <div class="item t">
        <span>事件</span>
      </div>
      <div class="item arr" @click="showType=true">
        <span><b>*</b>紧急程度</span>
        {{ IncidentLevel }}
      </div>
      <div class="item" style="display:block">
        <span><b>*</b>事件说明</span>
        <textarea class="textarea" v-model="IncidentContent" placeholder="请详细描写事件说明"></textarea>
        <!-- </div>
        <div class="item"> -->
        <van-uploader style="margin-top:10px" v-model="Imgs" max-count="5" :after-read="afterRead" multiple/>
      </div>
      <!-- </div>
      <div class="gc-page-project-wrap"> -->
      <div class="item t">
        <span>处理要求</span>
      </div>
      <div class="item arr" @click="showMemberOne=true">
        <span><b>*</b>处理人员：</span>
        {{ activeNameOne }}
      </div>

      <div class="item" style="display:block">
        <span><b>*</b>处理要求</span>
        <textarea class="textarea" v-model="IncidentRequire" placeholder="请详细描写处理要求"></textarea>
      </div>
      <div class="item arr" @click="showEndTime=true">
        <span><b>*</b>截止日期</span>
        {{ EndTime }}
      </div>

    </div>

    <div class="submit-btn" @click="handleCreatePro">提 交</div>


    <van-popup v-model="showType" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsType"
        :default-index="$route.query.type"
        @confirm="onConfirmType"
        @cancel="showType=false"
      />
    </van-popup>
    <van-popup v-model="showEndTime" position="bottom">
      <van-datetime-picker
        type="datetime"
        title="截止时间"
        v-model="EndDate"
        @confirm="onConfirmEndTime"
        @cancel="showEndTime=false"
      />
    </van-popup>

    <!-- 验收人员 -->
    <van-popup v-model="showMemberOne" position="bottom">
      <div class="opt-btn">
        <div class="cancel" @click="showMemberOne=false">取消</div>
        <div class="sure" @click="showMemberOne=false">确定</div>
      </div>
      <van-tree-select
        :items="items"
        :active-id.sync="activeId"
        :main-active-index.sync="activeIndexOne"
        @click-item="handleTree"
      />
    </van-popup>
    <!-- 出资人员 -->
    <!-- <van-popup v-model="showMembers" @close="handleClose" position="bottom" >
        <div class="opt-btn">
            <div class="cancel" @click="showMembers=false">取消</div>
            <div class="sure" @click="showMembers=false">确定</div>
        </div>
        <van-tree-select
        :items="items"
        :active-id.sync="activeIds"
        :main-active-index.sync="activeIndex"
        />
    </van-popup> -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      IncidentContent: '',
      IncidentRequire: '',
      EndTime: '请选择',
      EndDate: new Date(),
      IncidentLevel: '请选择',
      columnsType: ['A', 'B', 'C', 'D', 'E'],

      showType: false,
      showEndTime: false,

      showMembers: false,
      showMemberOne: false,
      items: [],
      activeId: '',
      activeIds: [],
      activeNameOne: '请选择',
      activeNames: [],
      tempActiveNames: [],
      activeIndexOne: 0,
      activeIndex: 0,

      Imgs: [],
      fileList: [],

      title: '添加事件'
    }
  },
  mounted() {
    document.querySelector('body').className = 'fff'
    this.WebGetBDepInfo()
    if (this.$route.query.sysno) {
      // 详情
      this.WebGetIncidentInfo(this.$route.query.sysno)
      this.title = '修改事件'
    }
  },
  methods: {
    handleCreatePro() {
      if (this.IncidentLevel == '请选择') {
        this.$toast('请选择事件紧急程度')
        return
      }
      if (!this.IncidentContent) {
        this.$toast('请详细描写事件说明')
        return
      }
      if (this.Imgs.length == 0) {
        this.$toast('请上传图片')
        return
      }
      if (this.activeId == '') {
        this.$toast('请选择处理人员')
        return
      }
      if (!this.IncidentRequire) {
        this.$toast('请详细描写处理要求')
        return
      }

      this.WebDSetIncidentInfo();
    },
    WebDSetIncidentInfo() {
      let Imgs = []
      this.Imgs.forEach(item => {
        Imgs.push(item.url)
      })
      let data = {
        UserSysno: localStorage.getItem('UserSysno'),//创建人编号
        IncidentContent: this.IncidentContent,
        IncidentLevel: this.IncidentLevel,
        IncidentRequire: this.IncidentRequire,
        Imgs: Imgs,
        EndTime: this.EndTime,
        // Remark: this.Remark,
        DealUserSysno: this.activeId,
      }

      console.log(data);
      // debugger
      this.$baseajax.sliceRequest(this.$base.baseEvent + '/WebDSetIncidentInfo', data, res => {
        console.log(res);
        if (res.ResponseCode == 1) {
          this.$toast('已提交成功等待审核')
          this.$router.back()
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },


    onConfirmType(v) {
      this.IncidentLevel = v
      this.showType = false
    },

    onConfirmEndTime(e) {
      this.EndDate = e
      let year = e.getFullYear()
      let month = e.getMonth() + 1
      let day = e.getDate()
      let hour = e.getHours()
      let minute = e.getMinutes()
      let second = e.getSeconds()

      // month = month < 10 ? '0' + month : month
      // day = day < 10 ? '0' + day : day

      this.EndTime = `${[year, month, day].map(this.formatNumber).join('-')} ${[hour, minute, second].map(this.formatNumber).join(':')}`;
      this.showEndTime = false
    },
    formatNumber(n) {
      n = n.toString()
      return n[1] ? n : `0${n}`
    },
    // 人员
    handleTree(e) {
      this.activeNameOne = e.text;
    },

    // 获取部门信息
    WebGetBDepInfo() {
      let data = {
        page: 1,
        pcount: 100
      }
      this.$baseajax.normalJsonp(this.$base.baseEvent + '/WebGetBDepInfo', data, res => {
        console.log(res);
        res = res.WebGetBDepInfoResult
        if (res.ResponseCode == 1) {
          for (let obj of res.ItemLst) {
            this.items.push({
              text: obj.DepInfo.Name,
              id: obj.DepInfo.Sysno,
              children: []
            })
          }
          // 获取人员列表
          this.WebGetItemLst()
        }
      }, err => {
      })
    },
    // 获取人员列表
    WebGetItemLst() {
      let data = {
        page: 1,
        pcount: 100
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetItemLst', data, res => {
        console.log(res);
        res = res.WebGetItemLstResult
        if (res.ResponseCode == 1) {
          for (let obj of res.ItemLst) {
            this.items.map(item2 => {
              if (obj.GovDepItem.Sysno == item2.id) {
                item2.children.push({
                  text: obj.Item.Name,
                  id: obj.Item.Sysno
                })
              }
              return item2
            })
          }
          console.log(this.items);
        }
      }, err => {
      })
    },
    onConfirmMoneyType(v, i) {
      console.log(v, i);
      this.moneyType = i
      this.showMoneyType = false
    },

    // 详情
    WebGetIncidentInfo(sysno) {
      let data = {
        IncidentSysno: sysno,
        UserSysno: localStorage.getItem('UserSysno'),
        QDetail: localStorage.getItem('IsSatis') || 0,
      }
      this.$baseajax.normalJsonp(this.$base.baseEvent + '/WebGetIncidentInfo', data, res => {
        console.log(res);
        res = res.WebGetIncidentInfoResult
        if (res.ResponseCode == 1) {
          let detailinfo = res.Item
          this.IncidentContent = detailinfo.IncidentContent;
          this.IncidentLevel = detailinfo.IncidentLevel
          this.IncidentRequire = detailinfo.IncidentRequire;
          let Imgs = detailinfo.Imgs.reduce((arr, element) => {
            arr.push({
              url: element,
              isImage: true
            })
            return arr
          }, []);
          this.Imgs = Imgs
          this.EndTime = detailinfo.EndTime
          this.activeId = detailinfo.DealUserSysno
          this.activeNameOne = detailinfo.DealUserName

        }
      }, err => {
      })
    },
    afterRead(file) {
      console.log(file);
      let arr = []
      if (file instanceof Array) {
        arr = file
      } else {
        arr[0] = file
      }
      arr.forEach(item => {
        let formData = new FormData()
        formData.append('file', item.file)
        this.$baseajax.postFile(this.$base.basePic, formData, res => {
          item.url = res.Data
        }, err => {
          console.log(err);
        })
      })
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type: mime});
    },

  },
  beforeCreate() {

    document.querySelector('body').className = 'fff'
  },
  destroyed() {
    document.querySelector('body').className = ''
  },
}
</script>

<style lang="less" scoped>
.average-wrap {
  margin-top: 0.2rem;
  display: flex;
  justify-content: flex-end;
}

.average-btn {
  width: 2rem;
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.3rem;
  color: #fff;
  background: #D32F2F;
  border-radius: .7rem;
}

.page-info-wrap {
  padding: 0.28rem;

  .item {
    padding: .4rem 0;
    border-bottom: 1px solid #eee;
    font-size: 0.37rem;
    color: #666666;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.t {
      font-weight: bold;
      color: #333333;
    }

    // /deep/.van-uploader{
    //     // background: #eee;
    //     border-radius: 100%;
    //     opacity: 0;
    //     margin: 0;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    // }
    // /deep/.van-uploader__upload{
    //     width: 1.47rem;
    //     height: 1.47rem;
    //     margin: 0;
    // }
    .img-wrap {
      position: relative;
      background: #eee;
      border-radius: 100%;
      overflow: hidden;

      img {
        display: block;
        width: 1.47rem;
        height: 1.47rem;
      }
    }

    span {
      color: #333333;

      b {
        color: #E4393C;
      }
    }

    .input {
      text-align: right;
      font-size: 0.37rem;
      color: #666666;
      width: 60%;
    }

    .textarea {
      width: 100%;
      margin-top: 0.4rem;
      display: block;
      padding: .2rem .3rem;
      height: 3rem;
      background-color: #f0f0f0;
      background: #f7f8fa;
      border-radius: 0.13rem;
      font-size: 0.37rem;
      color: #666666;
    }

    &.arr {
      position: relative;
      padding-right: 0.3rem;

      &:after {
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.1rem;
        content: '';
        width: 0.2rem;
        height: 0.2rem;
        border-top: 1px solid #999999;
        border-left: 1px solid #999999;
        transform: rotate(135deg);
      }
    }
  }
}

/deep/ .van-tree-select__nav {
  // display: none;
}

.submit-btn {
  // position: fixed;
  // bottom: 0.3rem;
  // left: 0.6rem;
  margin: 1rem auto .5rem;
  width: 8.8rem;
  height: 1.04rem;
  line-height: 1.04rem;
  background-color: #D32F2F;
  box-shadow: 0rem 1px 0.09rem 0rem rgba(26, 26, 26, 0.29);
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.47rem;
  color: #ffffff;
}

/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, .5);
}


.gc-page-project-wrap {
  .page-dep-wrap {
    .item {
      display: flex;
      justify-content: space-between;
      position: relative;

      &.arr {
        padding-right: 0.3rem;

        &:after {
          display: block;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -0.1rem;
          content: '';
          width: 0.2rem;
          height: 0.2rem;
          border-top: 0.02667rem solid #999999;
          border-left: 0.02667rem solid #999999;
          -webkit-transform: rotate(135deg);
          transform: rotate(135deg);
        }
      }
    }
  }

  .page-member-wrap {
    margin-right: 0;
    padding-right: 0;
    padding-top: .1rem;
  }

  .review-btn .btn.dis {
    background: #ddd;
    border-color: #ddd;
  }
}

.page-member-wrap {
  margin-right: 0;
  padding-right: 0;
  padding-top: .1rem;
}

.review-btn .btn.dis {
  background: #ddd;
  border-color: #ddd;
}

.opt-btn {
  display: flex;
  font-size: .34rem;
  justify-content: space-between;
  padding: .25rem;
  // background: #fcfcfc;
  border-bottom: 1px solid #f5f5f5;

  .sure {
    color: #ee0a24;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/satisfaction/Add.vue